const ENVIRONMENT = (
    window.location.hostname === 'dlts.draftlinesmartsystem.com' ? {
        SERVER_ADDRESS_API: 'https://draftlinesmartsystem.com',
        SERVER_ADDRESS_IMAGE: 'https://bdplive.s3.amazonaws.com',
        SERVER_ADDRESS_WEB: 'https://draftlinesmartsystem.com'
    } : {
        SERVER_ADDRESS_API: 'https://devbdp.webthink.com',
        SERVER_ADDRESS_IMAGE: 'https://bdpdev.s3.amazonaws.com',
        SERVER_ADDRESS_WEB: 'https://devbdp.webthink.com'
    }
);

export const CONFIGS = {
    API: {
        ENDPOINT: ENVIRONMENT.SERVER_ADDRESS_API + '/JsonRPC.aspx',
        METHODS: {
            ACCOUNT_NOTES_POST: 'TechnicianAPIver3.UpdateLocation',
            BRAND_SEARCH_LIST_GET: 'AIBrandsAPI.GetDistributorsByBrandNameForAutocompleteText',
            BRAND_UPSERT: 'TechnicianAPIver3.InsertOrUpdateBrand',
            DISTRIBUTOR_SEARCH_LIST_GET: 'AIBrandsAPI.GetDistributorsForAutocompleteText',
            FAUCET_UPDATE: 'TechnicianAPIver2.UpdateFaucet',
            LOCATION_FAUCET_SELECTION_LISTS_GET: 'TechnicianAPIver2.GetSelectionData',
            KEG_DELETE: 'TechnicianAPIver2.RemoveKeg',
            KEG_HISTORY_GET: 'TechnicianAPIver2.GetKegsHistory',
            KEG_UPSERT: 'TechnicianAPIver2.InsertOrUpdateKeg',
            LOCATIONS_GET: 'TechnicianAPIver2.GetSystemWithParts',
            PART_GET: 'TechnicianAPIver2.GetPart',
            PART_GROUPS_INVENTORIES_GET: 'TechnicianAPIver2.GetPartsGroupsWithInventory',
            PART_UPSERT: 'TechnicianAPIver2.InsertOrUpdatePart',
            REQUEST_NOTES_POST: 'AIBrandsAPI.UpdateAITowerRequestNotes',
            SETTINGS_GET: 'TechnicianAPIver2.GetSettings',
            TOWER_PHOTO_REQUEST_DELETE: 'AIBrandsAPI.RejectAITowerRequest',
            TOWER_PHOTO_REQUEST_GET: 'AIBrandsAPI.GetAITowerRequestDetails',
            TOWER_PHOTO_REQUEST_POST: 'AIBrandsAPI.CompleteAITowerRequest',
            TOWER_PHOTO_REQUESTS_GET: 'AIBrandsAPI.GetAITowerRequests'
        }
    },
    FAUCET_EDIT: {
        BRANDS_LIMIT: 200
    },
    STORAGE: {
        IMAGE_LOCATION_URL: ENVIRONMENT.SERVER_ADDRESS_IMAGE + '/images/locations/{ID}.png',
        IMAGE_TOWER_URL: {
            EDITED: ENVIRONMENT.SERVER_ADDRESS_IMAGE + '/towerai/{ID}_cropped.jpeg',
            ORIGINAL: ENVIRONMENT.SERVER_ADDRESS_IMAGE + '/towerai/{ID}_orig.jpeg'
        },
        IMAGE_USER_URL: ENVIRONMENT.SERVER_ADDRESS_IMAGE + '/images/users/user{ID}.png'
    },
    URLS: {
        SYSTEM: ENVIRONMENT.SERVER_ADDRESS_WEB + '/systems.aspx?locid={LOCATION_ID}&sysid={SYSTEM_ID}&stid={STATION_ID}&tid={TOWER_ID}',
        TRIP: ENVIRONMENT.SERVER_ADDRESS_WEB + '/trips.aspx?id={ID}'
    }
};